export default function ExploreHeaderGraphic(props: React.ComponentProps<'svg'>): JSX.Element {
  return (
    <svg width={303} height={196} viewBox="0 0 303 196" fill="none" {...props}>
      <path
        d="M29.83 80.142a30.484 30.484 0 00-11.2 11.914A26.48 26.48 0 007.182 79.787c4.648-3 8.463-7.1 11.12-11.909A32.846 32.846 0 0029.83 80.142z"
        fill="bg"
        stroke="border.emphasized"
        strokeWidth={6}
      />
      <path
        d="M46.89 148.999l-1.132-4.5a23.489 23.489 0 00-17.217-17.091l2.238-1.118a31.134 31.134 0 0016.111-19.634 30.525 30.525 0 0017.569 20.42l.78.332a27.56 27.56 0 00-17.23 17.936l-1.119 3.655z"
        fill="bg"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.89 148.999l1.12-3.655a27.527 27.527 0 012.487-5.717 27.572 27.572 0 0114.742-12.219l-.78-.332a30.532 30.532 0 01-17.569-20.42 31.135 31.135 0 01-16.11 19.634l-2.239 1.118a23.474 23.474 0 017.125 3.052 23.505 23.505 0 0110.092 14.039l1.132 4.5zm.415-15.44a33.595 33.595 0 016.01-6.286 36.547 36.547 0 01-6.492-6.897 37.157 37.157 0 01-5.965 6.402 29.523 29.523 0 016.447 6.781z"
        fill="neutrals.emphasized"
      />
      <path
        d="M75.906 92.52l-1.73-6.848a36.345 36.345 0 00-26.669-26.416l3.528-1.756a47.94 47.94 0 0024.871-30.218 47.008 47.008 0 0027.116 31.429l1.283.544a42.622 42.622 0 00-26.69 27.71l-1.709 5.556z"
        fill="bg"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.906 92.52l1.709-5.555a42.722 42.722 0 011.805-4.814 42.63 42.63 0 0124.885-22.895l-1.283-.545a47.018 47.018 0 01-27.116-31.428A47.933 47.933 0 0151.035 57.5l-3.528 1.755a36.379 36.379 0 017.722 2.83 36.356 36.356 0 0118.947 23.587l1.73 6.849zm.518-17.643a48.642 48.642 0 0114.888-15.79 53.027 53.027 0 01-15.488-16.574 53.953 53.953 0 01-14.775 15.948 42.376 42.376 0 0115.375 16.416z"
        fill="neutrals.emphasized"
      />
      <path
        d="M230.901 13.115c1.089-1.088 2.948-.59 3.346.897l15.538 57.99c.399 1.487-.962 2.848-2.449 2.449l-57.99-15.538c-1.487-.399-1.985-2.258-.896-3.346l42.451-42.452z"
        fill="pink.subtle"
        stroke="pink.border"
        strokeWidth={6}
      />
      <circle
        cx={261.924}
        cy={138.924}
        r={37.9236}
        fill="blue.muted"
        stroke="blue.border"
        strokeWidth={6}
      />
      <path
        d="M133.112 73.074l8.27 6.532a9.001 9.001 0 0011.35-.158l8.086-6.758c1.67-1.395 4.223-.604 4.812 1.49l2.852 10.146a9 9 0 009.274 6.544l10.515-.714c2.171-.148 3.772 1.993 3.017 4.034l-3.656 9.884a9 9 0 003.656 10.745l8.926 5.603c1.843 1.157 1.88 3.829.07 5.037l-8.768 5.847a9 9 0 00-3.357 10.842l3.928 9.78c.811 2.019-.73 4.203-2.904 4.116l-10.531-.423a9 9 0 00-9.089 6.798l-2.57 10.22c-.531 2.111-3.061 2.972-4.769 1.623l-8.27-6.531a8.999 8.999 0 00-11.349.157l-8.087 6.758c-1.67 1.395-4.223.604-4.812-1.49l-2.852-10.146a9.002 9.002 0 00-9.274-6.544l-10.515.714c-2.171.148-3.772-1.993-3.017-4.034l3.656-9.884a9 9 0 00-3.656-10.745l-8.926-5.603c-1.843-1.156-1.88-3.829-.07-5.036l8.768-5.848a9 9 0 003.357-10.842l-3.928-9.78c-.811-2.019.73-4.203 2.904-4.115l10.531.422a9 9 0 009.089-6.798l2.57-10.22c.531-2.11 3.061-2.972 4.769-1.623z"
        fill="yellow.muted"
        stroke="yellow.border"
        strokeWidth={6}
      />
    </svg>
  )
}
